import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import UsageFlowSection from "./components/UsageFlowSection";
import PersonalBusinessSection from "./components/PersonalBusinessSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen font-sans" style={{ background: "#080808", color: "#f5f5f5" }}>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <UsageFlowSection />
        <PersonalBusinessSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
